export default function AboutSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6 leading-tight">
              What Is an AllChinaBuy Spreadsheet?
            </h2>
            <div className="space-y-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              <p>
                An <strong>AllChinaBuy Spreadsheet</strong> is a categorized directory that helps users discover products, compare resources, and organize buying information efficiently. It serves as a carefully curated collection of seller links, product listings, and trusted vendor information, making the shopping experience on AllChinaBuy more streamlined for buyers around the world.
              </p>
              <p>
                Our directory collects useful resources in one place so users can spend less time searching and more time buying. Whether you are looking for the <strong>best allchinabuy spreadsheet</strong> for sneakers, clothing, or accessories, our platform organizes everything by category to help you jump straight to what matters most.
              </p>
              <p>
                Updated regularly and maintained by our editorial team, the <strong>free allchinabuy spreadsheet</strong> directory is designed to be the most comprehensive and beginner-friendly resource available online for the AllChinaBuy community in 2026.
              </p>
            </div>

            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-8 px-7 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Explore All Spreadsheets
              <i className="ri-arrow-right-line"></i>
            </a>

            <div className="flex gap-12 md:gap-16 mt-10">
              <div>
                <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">14</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Categories</p>
              </div>
              <div>
                <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">50+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Trusted Sellers</p>
              </div>
              <div>
                <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">Weekly</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">Updates</p>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="relative rounded-3xl overflow-hidden aspect-[3/4] max-w-sm mx-auto lg:max-w-none">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20premium%20lifestyle%20items%20including%20notebook%20watch%20leather%20wallet%20and%20small%20plant%20on%20cream%20marble%20surface%2C%20warm%20golden%20sunlight%20from%20left%2C%20editorial%20photography%2C%20sophisticated%20composition%2C%20clean%20aesthetic%2C%20warm%20neutral%20tones%2C%20high%20detail%2C%20professional%20catalog%20quality&width=800&height=1067&seq=about-img-v2-june2026&orientation=portrait"
                alt="Curated AllChinaBuy Spreadsheet Resources"
                title="AllChinaBuy Spreadsheet Curated Collection"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
              <div className="absolute top-4 left-4">
                <span className="px-3 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-800">
                  Curated
                </span>
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/50 to-transparent p-5">
                <p className="text-background-50 text-sm font-medium">Verified Sources</p>
                <p className="text-background-50/70 text-xs">Weekly Checks</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}